export const messages = {
    //sign up page
    FNAME_ERROR: 'First name must be at least 3 characters long',
    LNAME_ERROR: 'Last name must be at least 3 characters long',
    PASSWORD_ERROR: 'Password and confirm password do not match',
    PRIVACY_ERROR: 'Please accept the privacy policy',
    LOGIN_ERROR: 'Invalid credentials',
    LOGIN_FAILURE_DEVICE: 'Device limit exceeded. Please contact Dawraty Support for further assistance.',
    PASSWORD_SHORT: 'Password must be at least 6 characters long',
    COUNTRY_ERROR: 'Please select a country',
    MOBILE_ERROR: 'Please enter your mobile number',
    FILE_ERROR: 'Please upload the file in PDF format only',
    NO_RESULTS_FOUND: 'No results found',
};

export const ar_messages = {
    //sign up page
    FNAME_ERROR: 'يجب أن يكون الاسم الأول 3 أحرف على الأقل',
    LNAME_ERROR: 'يجب أن يكون اسم العائلة 3 أحرف على الأقل',
    PASSWORD_ERROR: 'كلمة المرور وتأكيد كلمة المرور غير متطابقتين',
    PRIVACY_ERROR: 'يرجى الموافقة على سياسة الخصوصية',
    LOGIN_ERROR: 'بيانات الدخول غير صحيحة',
    LOGIN_FAILURE_DEVICE: 'تم تجاوز الحد المسموح به للأجهزة. يرجى التواصل مع خدمة عملاء دوراتي للمساعدة.',
    PASSWORD_SHORT: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    COUNTRY_ERROR: 'يرجى اختيار الدولة',
    MOBILE_ERROR: 'يرجى إدخال رقم الهاتف المحمول',
    FILE_ERROR: 'يرجى رفع الملف بصيغة PDF فقط',
    NO_RESULTS_FOUND: 'لم يتم العثور على نتائج',
};

// universal constant message
